import { useEffect, useState, useMemo } from 'react'
import { callActions, type CallState } from '@/utils/callActions'

/**
 * React hook to use the global call actions and state
 * This hook provides access to the call state and actions with automatic re-rendering
 */
export function useCallActions() {
  const [state, setState] = useState<CallState>(() => callActions.getState())

  useEffect(() => {
    const unsubscribe = callActions.subscribe((newState) => {
      setState(newState)
    })

    return () => {
      unsubscribe()
    }
  }, [])

  // Memoize derived state to prevent unnecessary recalculations
  const pinnedParticipantInfo = useMemo(() => {
    return callActions.getPinnedParticipant()
  }, [state.pinnedParticipant, state.participants])
  
  const smallParticipants = useMemo(() => {
    return callActions.getSmallParticipants()
  }, [state.participants, state.pinnedParticipant])

  return {
    // State
    ...state,
    
    // Actions
    connectToRoom: callActions.connectToRoom,
    disconnectRoom: callActions.disconnectRoom,
    toggleMicrophone: callActions.toggleMicrophone,
    toggleCamera: callActions.toggleCamera,
    handleDeviceChange: callActions.handleDeviceChange,
    pinParticipant: callActions.pinParticipant,
    setShowDeviceSettings: callActions.setShowDeviceSettings,
    
    // Derived state (memoized)
    pinnedParticipantInfo,
    smallParticipants,
  }
}
